export default __webpack_public_path__ + "static/media/gallery-34.8bc12b6d.jpg";